module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" N° de Solicitud: " + _vm._s(_vm.tramite.id) + "\n    "), _c('div', {
    staticClass: "tramite-estado"
  }, [_c('v-chip', {
    attrs: {
      "label": "",
      "color": _vm.estados[_vm.tramite.estado],
      "text-color": "white"
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.tramite.estado ? _vm.tramite.estado.replace(/_/gi, ' ') : ''))])])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar_ventana($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalles),
      expression: "detalles"
    }],
    attrs: {
      "xs4": ""
    }
  }, [_c('detalle-doc', {
    attrs: {
      "solicitud": _vm.tramite,
      "pagos": _vm.pagos
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: {
      xs12: !_vm.detalles
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "margin-0 p-l-0 p-r-0 p-t-0"
  }, [_c('v-tooltip', {
    staticClass: "margin-0",
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detalles = !_vm.detalles
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.detalles ? 'chevron_left' : 'chevron_right'))]), _vm._v("\n              " + _vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + "\n            ")], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + " detalles")])], 1), _vm._v(" "), _vm._l((_vm.pagos), function(item, index) {
    return [_c('v-spacer'), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 && _vm.tramite.estado === 'APOSTILLADO') ? _c('v-tooltip', {
      staticClass: "margin-0",
      attrs: {
        "top": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.imprimir()
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("print")]), _vm._v(" IMPRIMIR EN HOJA MEMBRETADA\n            ")], 1), _vm._v(" "), _c('span', [_vm._v(" Versión para imprimir en hoja membretada")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
      staticClass: "margin-0",
      attrs: {
        "top": ""
      }
    }, [(_vm.$store.state.permissions['tramitesDoc:update'] && _vm.$store.state.user.id_rol === 3 && (item.estado == 'HABILITADO' || _vm.tramite.estado == 'REVISADO_ENTIDAD')) ? _c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "info",
        "disabled": item.estado == 'PAGADO'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.generarCpt(_vm.tramite, 'CANCILLERIA')
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("monetization_on")]), _vm._v(" REGENERAR CPT\n              ")], 1) : _vm._e(), _vm._v(" "), (item.estado == 'PAGADO') ? _c('span', [_vm._v("No se puede regenerar Código de Pago(CPT) de un trámite pagado")]) : _c('span', [_vm._v(" Regenerar Código de Pago(CPT)")])], 1)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pdf-container"
  }, [((_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3) && _vm.solicitud.firmante) ? _c('v-layout', {
    staticClass: "firma-detalle",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos firmante designado")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_nombre_completo) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cargo:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_cargo || '[no registrado]') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Entidad:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.entidad_nombre) + "\n            ")]), _vm._v(" "), (_vm.solicitud.firmante.certicado_token) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos firma en documento")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunSubject) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Certificado por:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunIssuer) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha inicio validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.inicioValidez) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha fin validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.finValidez) + " "), _c('br')]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pdf && _vm.tramite.id_archivo > 1) ? _c('pdf-view', {
    attrs: {
      "data": _vm.pdf,
      "url": _vm.urlPdf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tramite.id_archivo == 1) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n            No se adjuntó ningún documento PDF\n          ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57f48dc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/tramiteDoc/Detalle.vue
// module id = 521
// module chunks = 2